import "./KanbanStyle.scss";
import { MdCancel, MdAddCircle } from "react-icons/md";
import { motion } from "framer-motion";

// Animation Variants for framer motion animation
const animVariants = {
  opened: {
    opacity: 1,
    scale: 1,
    top: 70,
  },
  closed: {
    opacity: 0,
    scale: 0,
    top: 0,
  },
};

// Component used to render the AddTask popup modal
const AddTaskComponent = ({
  open,
  onCancel,
  onAddTask,
  onTaskChange,
  isDark,
}) => {
  return (
    <>
      <div
        className="task-modal-wrapper"
        style={{ visibility: open ? "visible" : "hidden" }}
      >
        <motion.div
          initial={{ scale: 0, top: 0, opacity: 0 }}
          variants={animVariants}
          animate={open ? "opened" : "closed"}
          className={`add-project-modal ${
            isDark ? "add-project-modal-dark" : ""
          } center-add-task`}
          // className="add-project-modal center-add-task"
        >
          <div>
            <h3>Add Task</h3>
            <div className="add-task-content">
              <input
                type="text"
                onChange={onTaskChange}
                placeholder="Enter Task"
              />
              <button onClick={onAddTask} className="icn-btn">
                <MdAddCircle size={22} />
              </button>
              <button onClick={onCancel} className="icn-btn secondary">
                <MdCancel size={22} />
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default AddTaskComponent;
